import Client from '../HttpClient';

const baseUrl = '/gateway/wombat-mgt/api/vs/manage-member';

const membersList = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/members`, data);
};

const member = (merchantId, memberId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/members/${memberId}`, data);
};

const gradesList = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/grades`, data);
};

const updateMemberPreference = (merchantId, memberId, data) => {
	return Client.put(`${baseUrl}/${merchantId}/members/${memberId}`, data);
};

const updateMemberGrade = (merchantId, memberId, data) => {
	return Client.put(`${baseUrl}/${merchantId}/members/${memberId}/grade`, data);
};

const gradeList = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/grades`, data);
};

const memberCodeRules = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/member-code-rules`, data);
};

const updateMemberCodeRules = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/member-code-rules`, data);
};

const deleteGrade = (merchantId, id) => {
	return Client.del(`${baseUrl}/${merchantId}/grades/${id}`);
};

const updateGrade = (merchantId, id, data) => {
	return Client.put(`${baseUrl}/${merchantId}/grades/${id}`, data);
};

const batchAddGrade = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/grades/batch`, data);
};

const purchaseActivities = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/purchase-activities`, data);
};

export default {
	membersList,
	member,
	gradesList,
	updateMemberPreference,
	updateMemberGrade,
	gradeList,
	memberCodeRules,
	updateMemberCodeRules,
	deleteGrade,
	updateGrade,
	batchAddGrade,
	purchaseActivities,
};
